<section class="relative min-h-160 lg:h-160 xl:h-160 overflow-visible pb-20">
  <!-- Image layers -->
  <div
    class="absolute inset-0 bg-cover bg-center transition-opacity duration-[3000ms] ease-in-out"
    [ngStyle]="{ 'background-image': 'url(' + view.imageLayer1 + ')' }"
    [ngClass]="{ 'opacity-100': view.activeLayer === 1, 'opacity-0': view.activeLayer !== 1 }">
  </div>
  <div
    class="absolute inset-0 bg-cover bg-center transition-opacity duration-[3000ms] ease-in-out"
    [ngStyle]="{ 'background-image': 'url(' + view.imageLayer2 + ')' }"
    [ngClass]="{ 'opacity-100': view.activeLayer === 2, 'opacity-0': view.activeLayer !== 2 }">
  </div>

  <!-- CTA Text -->
  <div class="relative flex flex-col h-full pt-10 items-start z-10 px-4 md:px-10 max-w-4xl">
    @if(view.site?.id != 79) {
      <h1 class="banner-hero-title-shadow text-4xl md:text-6xl text-white font-extrabold leading-tight tracking-tight">
        Discover Your Next Adventure
      </h1>
      <p class="banner-hero-body-shadow mt-4 text-lg md:text-xl text-white leading-relaxed max-w-prose">
        Discover the world like never before. With every trip, unlock new experiences, explore vibrant cultures,
        and create memories that last a lifetime. Start your adventure today and see where travel can take you!
      </p>
      <button
        class="mt-8 inline-block bg-primary-500 hover:bg-primary-100 text-primary-100 hover:text-primary-500 font-bold py-4 px-8 rounded-xl shadow-lg transition duration-500"
        (click)="onScrollToAnchor()">
        Explore Now
      </button>
    }
    @if(view.site?.id === 79) {
      <p class="text-lg md:text-xl font-narrow text-white banner-hero-body-shadow max-w-prose">
        With over 60 years of experience, we pride ourselves on delivering a comprehensive concierge-style service
        designed to save you time and optimize your travel investment. Our team strives to curate personalized travel experiences
        that reflect your unique priorities.
      </p>
      <button
        class="mt-8 inline-block bg-primary-500 hover:bg-primary-100 text-primary-100 text-lg md:text-xl font-narrow tracking-wider hover:text-primary-500 py-4 px-8 rounded-xl shadow-lg transition duration-500"
        (click)="onScrollToAnchor()">
        Explore Now
      </button>
    }
  </div>

  <!-- Search Widget: hanging below the banner -->
   @if(view.site?.id !== 79) {
    
  }
  <div class="absolute left-1/2 -bottom-10 transform -translate-x-1/2 w-[90%] max-w-7xl z-20">
    <!-- <button
      class="px-3 py-1 text-sm rounded-md border border-gray-300 bg-white/20 backdrop-blur-sm text-gray-700 hover:bg-white/30 transition"
      (click)="toggleWidget()">
      {{ isThomalexWidget ? 'Disable' : 'Enable' }}
    </button> -->

    
      <ul
        class="flex justify-start md:justify-center text-sm p-4 font-medium text-center bg-white rounded-t-lg w-full max-w-2xl overflow-x-auto"
        id="default-styled-tab" role="tablist">
        
          <li class="me-2">
            <button
              class="inline-block text-black px-5 py-2 hover:bg-primary-100 hover:text-primary-500 rounded-md uppercase transition [&.active]:text-primary-500 [&.active]:bg-primary-100"
              id="fights-tab" [class.active]="view.selectedTab === 'flight'" (click)="selectTab('flight')" type="button"
              role="tab" aria-controls="flights" aria-selected="true">
              Flights
            </button>
          </li>
        
        <li class="me-2">
          <button
            class="inline-block text-black px-5 py-2 rounded-md hover:text-primary-500 hover:bg-primary-100 uppercase transition [&.active]:text-primary-500 [&.active]:bg-primary-100"
            id="Packages-tab" [class.active]="view.selectedTab === 'package'" (click)="selectTab('package')" type="button"
            role="tab" aria-controls="packages" aria-selected="view.selectedTab === 'package'">
            Packages
          </button>
        </li>
      </ul>
    
    <div id="default-styled-tab-content" class="bg-white shadow-2xl rounded-b-xl md:rounded-tr-xl">
      @if (view.selectedTab === 'flight') {
      <div class="md:rounded-lg">
        <search-widget [isThomalexWidget]="isThomalexWidget" [panel]="{ type: 'flight' }" (tripChange)="tripChanged($event)"
          (searchChange)="searchChanged($event)"></search-widget>
      </div>
      } @if (view.selectedTab === 'package') {
      <div class="md:rounded-lg">
        <search-widget [isThomalexWidget]="isThomalexWidget" [panel]="{ type: 'package' }" (tripChange)="tripChanged($event)"
          (searchChange)="searchChanged($event)"></search-widget>
      </div>
      }
      @if(view.selectedTab === 'flight' && view.site?.id === 79 && isThomalexWidget) {
      <!-- <div class="flex flex-col items-center justify-center mb-10 md:mt-5 lg:mt-10 z-50">
        <div class="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-primary-500"></div>
      </div> -->
      <div class="relative overflow-hidden max-h-[550px]" [hidden]="view.selectedTab !== 'flight'">
        <div id="thomalex-widget" #thomalexWidget [attr.data-widget]="thomalexUrl" class="w-full mt-3 px-5"
          style="height: 500px;">
        </div>
      </div>
      }
    </div>
  </div>
</section>

@if(view.site?.id === 79) {
  <div class="flex flex-col w-full pt-20 pb-10 px-6 md:px-12 items-center text-center bg-gradient-to-b from-gray-50 to-white shadow-inner">
    <h2 class="text-3xl md:text-4xl font-extrabold text-gray-800 mb-6 tracking-tight leading-snug">
      Travel With Confidence
    </h2>
    <p class="text-lg md:text-xl text-gray-600 leading-relaxed max-w-3xl">
      We understand that entrusting someone with your travel planning is a significant decision —
      one that requires confidence in both the people and the process.
      <br>
      At <span class="font-semibold text-primary-500">Stellenbosch Travel</span>,
      we aim to make that choice easier by offering a level of service that is reliable and rooted in genuine expertise.
    </p>
  </div>
}
